import axios from "axios";
import { getter } from "../../utils/storage";
import Swal from "sweetalert2";

const baseURL = process.env.REACT_APP_API_URL;
const headers = {};

const axiosInstance = axios.create({
    baseURL,
    headers
})

axiosInstance.interceptors.request.use((req) => {

    const timezoneOffset = new Date().getTimezoneOffset();
    const token = getter("kidoProtectUserAccessToken");
    headers["language"] = "en"
    headers["version_code"] = 20000
    headers['Authorization'] = token
    headers['timezone_offset'] = timezoneOffset
    req.headers = headers;
    return req;
})

axiosInstance.interceptors.response.use((res) => {
    return new Promise((resolve, reject) => {
        resolve(res);
    })
},
    (error) => {
        if (!error.response) {
            return new Promise((resolve, reject) => {
                reject(error)
            })
        }

        if (error.response.status === 401 || error.response.status === 402) {
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: error.response.data.message,
                timer: 2000,
                showConfirmButton: false
            });
            setTimeout(() => {
                localStorage.clear();
                // history.push()
                window.location = '/auth/login';
            }, 2000)
        } else {
            return new Promise((resolve, reject) => {
                reject(error);
            })
        }
    }
)

export default axiosInstance;